import React, { useState } from 'react';
import { Button } from './ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const PayPalButton = ({ selectedSize, selectedColor, boyshortsSize, boyshortsColor, quantity, productData, onError }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handlePayPalCheckout = async () => {
    if (!selectedSize) {
      alert('Please select a size first');
      return;
    }
    if (productData?.id === 'bundle' && !boyshortsSize) {
      alert('Please select a size for your free boyshorts.');
      document.querySelector('[data-testid="boyshorts-size-section"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    setIsProcessing(true);

    try {
      if (window.fbq) {
        window.fbq('track', 'AddToCart', {
          content_name: productData.name,
          content_ids: [selectedColor + '-' + selectedSize],
          content_type: 'product',
          value: productData.price,
          currency: 'USD'
        });
      }

      if (window.fbq) {
        window.fbq('track', 'InitiateCheckout', {
          content_name: productData.name,
          content_ids: [selectedColor + '-' + selectedSize],
          content_type: 'product',
          value: productData.price,
          currency: 'USD'
        });
      }

      const response = await axios.post(`${API}/paypal/create-order`, {
        product_id: productData.id,
        size: selectedSize,
        color: selectedColor,
        boyshorts_size: boyshortsSize || null,
        boyshorts_color: boyshortsColor || null,
        quantity: quantity,
        origin_url: window.location.origin
      });

      const { order_id } = response.data;

      if (!order_id) {
        throw new Error('No order ID received from PayPal');
      }

      // Redirect to PayPal for approval
      const approvalUrl = `https://www.paypal.com/checkoutnow?token=${order_id}`;
      window.location.href = approvalUrl;

    } catch (error) {
      setIsProcessing(false);
      
      if (onError) {
        onError(error);
      } else {
        alert('Failed to process PayPal checkout. Please try again.');
      }
    }
  };

  return (
    <Button
      onClick={handlePayPalCheckout}
      disabled={isProcessing || !selectedSize}
      className="w-full bg-[#0070ba] hover:bg-[#005ea6] text-white text-lg py-7 rounded-xl shadow-2xl transform hover:scale-105 transition-all duration-300 font-bold disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {isProcessing ? (
        <span className="flex items-center justify-center">
          <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Processing...
        </span>
      ) : (
        <span className="flex items-center justify-center">
          <svg className="w-6 h-6 mr-2" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.067 8.478c.492.88.556 2.014.3 3.327-.74 3.806-3.276 5.12-6.514 5.12h-.5a.805.805 0 00-.794.68l-.04.22-.63 3.993-.028.14a.806.806 0 01-.795.68H7.792a.538.538 0 01-.531-.612l.047-.267 1.004-6.355.03-.176a.805.805 0 01.795-.681h1.643c3.238 0 5.774-1.314 6.514-5.12.313-1.607.22-2.923-.504-3.9-.152-.206-.326-.392-.52-.56a6.314 6.314 0 00-1.054-.622 9.09 9.09 0 00-.61-.26c-.382-.137-.8-.237-1.25-.307-.238-.037-.488-.06-.748-.073-.165-.008-.335-.012-.51-.012H7.937a.806.806 0 00-.795.681l-1.47 9.322a.538.538 0 00.531.612h2.894l.726-4.597.029-.176a.805.805 0 01.795-.681h.828c1.869 0 3.332-.76 3.761-2.958.178-.913.114-1.677-.226-2.272-.153-.268-.357-.494-.608-.68zm.8-2.156a7.197 7.197 0 00-2.262-.623c-.438-.067-.9-.1-1.383-.1H8.438a1.07 1.07 0 00-1.058.907L5.784 18.502a.9.9 0 00.889 1.023h3.15a1.069 1.069 0 001.058-.907l.628-3.979a1.069 1.069 0 011.058-.907h.833c4.3 0 7.672-1.746 8.655-6.799.411-2.116.224-3.88-.93-5.116a5.616 5.616 0 00-1.258-1.096z"/>
          </svg>
          Pay with PayPal
        </span>
      )}
    </Button>
  );
};
